import { Hidden, StepContent, StepLabel, Stepper } from "@material-ui/core";

import DatosCompania from "../formulario/DatosCompania";
import DomicilioFiscal from "../formulario/DomicilioFiscal";
import EnviarSolicitud from "../formulario/EnviarSolicitud";
import { Fragment } from "react";
import GiroPrincipal from "../formulario/GiroPrincipal";
import InformacionComplementaria from "../formulario/InformacionComplementaria";
import { Step } from "@material-ui/core";
import { enumProveedorStep } from "../../settings/enumConfig";
import { useProveedoresProspectos } from "../../context/ProveedoresProspectosContext";

const ProveedoresStepper = () => {
    const { activeStep, provedoresSteps } = useProveedoresProspectos();

    return (
        <Fragment>
            <Hidden smDown>
                <main className="contenido minified container">
                    <Stepper activeStep={activeStep} alternativeLabel style={{ marginBottom: 50 }}>
                        {provedoresSteps.map((step, i) => (
                            <Step key={i}>
                                <StepLabel error={step.error}>{step.name}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === enumProveedorStep.DatosCompania && <DatosCompania />}
                    {activeStep === enumProveedorStep.GiroPrincipal && <GiroPrincipal />}
                    {activeStep === enumProveedorStep.DomicilioFiscal && <DomicilioFiscal />}
                    {activeStep === enumProveedorStep.InformacionComplementaria && <InformacionComplementaria />}
                    {(activeStep === enumProveedorStep.EnviarSolicitud || activeStep === enumProveedorStep.SolicitudEnviada) && (
                        <EnviarSolicitud />
                    )}
                </main>
            </Hidden>
            <Hidden mdUp>
                <main className="contenido container">
                    <Stepper activeStep={activeStep} orientation="vertical">
                        <Step>
                            <StepLabel error={provedoresSteps[0].error}>{provedoresSteps[0].name}</StepLabel>
                            <StepContent>
                                <DatosCompania />
                            </StepContent>
                        </Step>
                        <Step>
                            <StepLabel error={provedoresSteps[1].error}>{provedoresSteps[1].name}</StepLabel>
                            <StepContent>
                                <GiroPrincipal />
                            </StepContent>
                        </Step>
                        <Step>
                            <StepLabel error={provedoresSteps[2].error}>{provedoresSteps[2].name}</StepLabel>
                            <StepContent>
                                <DomicilioFiscal />
                            </StepContent>
                        </Step>
                        <Step>
                            <StepLabel error={provedoresSteps[3].error}>{provedoresSteps[3].name}</StepLabel>
                            <StepContent>
                                <InformacionComplementaria />
                            </StepContent>
                        </Step>
                        <Step
                            active={activeStep === enumProveedorStep.EnviarSolicitud || activeStep === enumProveedorStep.SolicitudEnviada}
                        >
                            <StepLabel error={provedoresSteps[4].error}>{provedoresSteps[4].name}</StepLabel>
                            <StepContent>
                                <EnviarSolicitud />
                            </StepContent>
                        </Step>
                    </Stepper>
                </main>
            </Hidden>
        </Fragment>
    );
};

export default ProveedoresStepper;
